// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".send-emergency-transport-patient-table-component .detail-btn[data-v-2fb0493f],.send-emergency-transport-patient-table-component .print-btn[data-v-2fb0493f]{width:64px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
